import { INavRoute, IRouteGroup } from '../models/navigation';

export const routes = {
  purchaseHistory: {
    path: (features) =>
      features.ENABLE_NEW_PURCHASE_HISTORY_PAGE
        ? '/myaccount/purchase-history'
        : '/b2b/account/view/order/summary',
    label: 'Purchase History',
    external: true,
    shouldShow: true,
  },
  onlineOrders: {
    path: (features) =>
      features.ENABLE_NEW_PURCHASE_HISTORY_PAGE
        ? '/myaccount/purchase-history'
        : '/order/view/summary',
    label: 'Online Orders',
    external: true,
    shouldShow: true,
  },
  inStoreEReceipts: {
    path: '/order/view/ereceipt/summary',
    label: 'In-Store e-Receipts',
    external: true,
    shouldShow: true,
  },
  inStoreOrders: {
    path: '/order/view/instoresummary',
    label: 'In-Store Orders',
    external: true,
    shouldShow: true,
  },
  buyItAgain: {
    path: '/buyitagain',
    label: 'Buy It Again',
    external: true,
    shouldShow: true,
  },
  b2cSubscriptions: {
    path: '/account/view/ordersubscription',
    label: 'Subscriptions',
    external: true,
    shouldShow: true,
  },
  subscriptions: {
    path: '/b2b/account/view/ordersubscription',
    label: 'Subscriptions',
    external: true,
    shouldShow: true,
  },
  businessTools: {
    path: '/myaccount/business-tools',
    label: 'Track Business Spend',
    external: true,
    shouldShow: true,
  },
  downloads: {
    path: '/myaccount/downloads',
    label: 'Downloads',
    external: true,
    shouldShow: true,
  },
  programDetails: {
    path: '/myaccount/proxtraprogramdetails',
    label: 'Program Details',
    external: true,
    shouldShow: (loyaltyMembershipDetails, userState, customer) => {
      return customer?.role?.toUpperCase() === 'ADMIN';
    },
  },
  proXtraPerks: {
    path: (features) => {
      return features.ENABLE_NEW_PERKS_PAGE
        ? '/myaccount/proXtraPerks'
        : '/b2b/account/view/proXtraPerks';
    },
    label: 'Pro Xtra Perks',
    external: true,
    shouldShow: (loyaltyMembershipDetails, userState, customer) => {
      return (
        !!loyaltyMembershipDetails?.customerInfo?.enrolledInPerksProgram &&
        customer?.role?.toUpperCase() === 'ADMIN'
      );
    },
  },
  pricingBenefits: {
    path: (features) => {
      return features.ENABLE_NEW_PROXTRA_PRICING_PAGE
        ? '/myaccount/proXtraPricing'
        : '/b2b/account/view/proXtraPricing';
    },
    label: 'Pricing Benefits',
    external: true,
    shouldShow: true,
  },
  jobQuotes: {
    path: (features) => {
      return features.ENABLE_NUCLEUS_QUOTE_EXPERIENCE
        ? '/quote/list'
        : '/b2b/account/view/quote/list';
    },
    label: 'Job Quotes',
    external: true,
    shouldShow: true,
  },
  poJobNames: {
    path: (features) =>
      features.ENABLE_NEW_POJOBS
        ? '/myaccount/pojobnames'
        : '/b2b/account/view/pojobname',
    label: 'PO/Job Names',
    external: true,
    shouldShow: (loyaltyMembershipDetails, userState, customer) => {
      return customer?.role?.toUpperCase() === 'ADMIN';
    },
  },
  productLists: {
    path: '/list/view/summary',
    label: 'Product Lists',
    external: true,
    shouldShow: true,
  },
  profile: {
    path: '/myaccount/profile',
    label: 'Profile',
    external: true,
    shouldShow: true,
  },
  b2cMobileMenu: {
    path: '/myaccount/profile/menu',
    label: 'Profile',
    external: true,
    shouldShow: true,
  },
  b2bDashboard: {
    path: (features) =>
      features.ENABLE_NEW_ACCOUNT_DASHBOARD
        ? '/myaccount/dashboard'
        : '/b2b/account/view/landingpage',
    label: 'Account',
    external: true,
    shouldShow: true,
  },
  b2cDashboard: {
    path: '/myaccount/dashboard',
    label: 'Account',
    external: true,
    shouldShow: true,
  },
  b2cAddresses: {
    path: '/myaccount/addresses',
    label: 'Addresses',
    external: true,
    shouldShow: true,
  },
  addresses: {
    path: '/myaccount/addresses',
    label: 'Addresses',
    external: true,
    shouldShow: true,
  },
  militaryDiscount: {
    path: '/military/discount',
    label: 'Military Discount Benefit',
    external: true,
    shouldShow: true,
  },
  addManageUsers: {
    path: (features) =>
      features.ENABLE_NEW_ADDMANAGE_USERS
        ? '/myaccount/addmanageusers'
        : '/b2b/account/view/manageusers',
    label: 'Add/Manage Users',
    external: true,
    shouldShow: (loyaltyMembershipDetails, userState, customer) => {
      return customer?.role?.toUpperCase() === 'ADMIN';
    },
  },
  securityPassword: {
    path: '/myaccount/security',
    label: 'Security & Password',
    external: true,
    shouldShow: true,
  },
  b2cNotificationPreferences: {
    path: (features) =>
      features.ENABLE_NEW_B2C_PREFERENCE_LINK
        ? '/myaccount/preferences'
        : '/account/view/emailsubscription',
    label: 'Communication Preferences',
    external: true,
    shouldShow: true,
  },
  notificationPreferences: {
    path: '/myaccount/preferences',
    label: 'Communication Preferences',
    external: true,
    shouldShow: true,
  },
  linkedAccounts: {
    path: '/myaccount/linked-accounts',
    label: 'Linked Accounts',
    external: true,
    shouldShow: (loyaltyMembershipDetails, userState, customer) => {
      return (
        !!(
          userState?.customer?.hierarchyOrgId || userState?.customer?.companyId
        ) && customer?.role?.toUpperCase() === 'ADMIN'
      );
    },
  },
  b2cCardsAccounts: {
    path: (features) => {
      return features.ENABLE_NEW_PAYMENTS_PAGE
        ? '/myaccount/payments'
        : '/account/view/paymentcards';
    },
    label: 'Cards & Accounts',
    external: true,
    shouldShow: true,
  },
  cardsAccounts: {
    path: (features) =>
      features.ENABLE_NEW_PAYMENTS_PAGE
        ? '/myaccount/payments'
        : '/b2b/account/view/paymentcards',
    label: 'Cards & Accounts',
    external: true,
    shouldShow: true,
  },
  b2cHomeDepotCreditCard: {
    path: '/account/view/thdcreditcard',
    label: 'Home Depot Credit Cards',
    external: true,
    shouldShow: true,
  },
  homeDepotCreditCard: {
    path: '/b2b/account/view/thdcreditcard',
    label: 'Home Depot Credit Cards',
    external: true,
    shouldShow: true,
  },
  giftCards: {
    path: '/c/Gift_Cards',
    label: 'Gift Cards',
    external: true,
    shouldShow: true,
  },
  proAllowanceManagement: {
    path: '/b2b/account/view/manageProAllowances',
    label: 'Pro Allowance Management',
    external: true,
    shouldShow: (loyaltyMembershipDetails, userState, customer) => {
      return (
        customer?.role?.toUpperCase() === 'ADMIN' &&
        !!loyaltyMembershipDetails?.proTiers?.benefitTags?.find(
          ({ tagName }) => {
            return tagName === 'runnerAllowance';
          },
        )
      );
    },
  },
  instantCheckout: {
    path: '/account/view/instantcheckout',
    label: 'Instant Checkout',
    external: true,
    shouldShow: true,
  },
  windowTreatments: {
    path: 'https://install.homedepot.com/MyWindowTreatments',
    label: 'Window Treatments',
    external: true,
    shouldShow: true,
  },
  pathToProNetwork: {
    path: '/path-to-pro-network',
    label: 'Path to Pro Network',
    external: true,
    shouldShow: true,
  },
} as const satisfies Record<string, INavRoute>;

export const routeGroups: IRouteGroup[] = [
  {
    title: 'Purchases',
    links: [
      routes.onlineOrders,
      routes.inStoreOrders,
      routes.inStoreEReceipts,
      routes.b2cSubscriptions,
    ],
  },
  {
    title: 'Payment Methods',
    links: [
      routes.b2cCardsAccounts,
      routes.b2cHomeDepotCreditCard,
      routes.instantCheckout,
    ],
  },
  {
    title: 'Account Settings',
    links: [
      routes.profile,
      routes.b2cAddresses,
      routes.militaryDiscount,
      routes.securityPassword,
      routes.b2cNotificationPreferences,
    ],
  },
  {
    title: 'Plan Your Projects',
    links: [routes.productLists, routes.windowTreatments],
  },
];

export const b2bRouteGroups: IRouteGroup[] = [
  {
    title: 'Purchases',
    links: [
      routes.purchaseHistory,
      routes.buyItAgain,
      routes.subscriptions,
      routes.businessTools,
      routes.downloads,
    ],
  },
  {
    title: 'Pro Xtra Program',
    links: [
      routes.programDetails,
      routes.proXtraPerks,
      routes.pricingBenefits,
      routes.pathToProNetwork,
    ],
  },
  {
    title: 'Plan Your Jobs',
    links: [routes.jobQuotes, routes.poJobNames, routes.productLists],
  },
  {
    title: 'Account Settings',
    links: [
      routes.profile,
      routes.addresses,
      routes.militaryDiscount,
      routes.addManageUsers,
      routes.securityPassword,
      routes.notificationPreferences,
      routes.linkedAccounts,
    ],
  },
  {
    title: 'Payment Methods',
    links: [
      routes.cardsAccounts,
      routes.homeDepotCreditCard,
      routes.proAllowanceManagement,
    ],
  },
];
